import jwtUtils from './jwtUtils';

const LOGIN_ALERT_SESSION_KEY_PREFIX = 'gestion-moras-login-alert-shown';
const LOGIN_ALERT_CACHE_KEY_PREFIX = 'gestion-moras-login-alert-cache';
const LOGIN_ALERT_CACHE_TTL_MS = 5 * 60 * 1000;

function getLoginAlertSessionKey(role) {
  const sessionId = jwtUtils.getRefreshTokenIDFromCookie() || 'unknown-session';
  return `${LOGIN_ALERT_SESSION_KEY_PREFIX}:${role}:${sessionId}`;
}

function getLoginAlertCacheKey(role) {
  const sessionId = jwtUtils.getRefreshTokenIDFromCookie() || 'unknown-session';
  return `${LOGIN_ALERT_CACHE_KEY_PREFIX}:${role}:${sessionId}`;
}

export function wasLoginAlertShown(role) {
  try {
    return sessionStorage.getItem(getLoginAlertSessionKey(role)) === 'true';
  } catch (error) {
    return false;
  }
}

export function markLoginAlertAsShown(role) {
  try {
    sessionStorage.setItem(getLoginAlertSessionKey(role), 'true');
  } catch (error) {
    // Ignore storage access errors and allow the alert to behave normally.
  }
}

export function getCachedLoginAlert(role) {
  try {
    const rawValue = sessionStorage.getItem(getLoginAlertCacheKey(role));
    if (!rawValue) {
      return null;
    }

    const parsedValue = JSON.parse(rawValue);
    if (
      !parsedValue ||
      typeof parsedValue !== 'object' ||
      typeof parsedValue.cachedAt !== 'number' ||
      !parsedValue.value
    ) {
      sessionStorage.removeItem(getLoginAlertCacheKey(role));
      return null;
    }

    if (Date.now() - parsedValue.cachedAt > LOGIN_ALERT_CACHE_TTL_MS) {
      sessionStorage.removeItem(getLoginAlertCacheKey(role));
      return null;
    }

    return parsedValue.value;
  } catch (error) {
    return null;
  }
}

export function cacheLoginAlert(role, value) {
  try {
    sessionStorage.setItem(
      getLoginAlertCacheKey(role),
      JSON.stringify({
        cachedAt: Date.now(),
        value,
      })
    );
  } catch (error) {
    // Ignore storage access errors and allow the alert to behave normally.
  }
}

export function clearLoginAlertSessionState() {
  try {
    Object.keys(sessionStorage)
      .filter(
        (key) =>
          key.startsWith(`${LOGIN_ALERT_SESSION_KEY_PREFIX}:`) ||
          key.startsWith(`${LOGIN_ALERT_CACHE_KEY_PREFIX}:`)
      )
      .forEach((key) => sessionStorage.removeItem(key));
  } catch (error) {
    // Ignore storage access errors during cleanup.
  }
}
